// i18n area 'system' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da system.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/system.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './system'

export const ptBR: DeepPartial<typeof enUS> = {
  explorer: {
    kinds: {
      catalogFile: 'Arquivo de catálogo',
      ociRegistry: 'Registro OCI',
      user: 'Usuário'
    }
  },
  tags: {
    save: 'Salvar',
    saveError: 'Impossível salvar as tags'
  },
  scopes: {
    protectionDefault: 'Padrão do cluster'
  },
  licensing: {
    devStage: 'Fase de desenvolvimento: o product key é aceito tal como está, juntamente com os limites aqui declarados; a validação com chave assinada chegará numa release futura.'
  },
  rbac: {
    principalUser: 'Usuário'
  },
  groups: {
    membersPlaceholder: 'Adicionar usuário…'
  },
  users: {
    title: 'Usuários',
    createTitle: 'Criar usuário',
    editTitle: 'Editar usuário',
    username: 'Nome de usuário',
    password: 'Senha',
    initialPassword: 'Senha inicial',
    initialPasswordHint: 'O usuário terá de a alterar no primeiro início de sessão',
    setPasswordTitle: 'Definir senha',
    setPasswordHint: 'Substituição administrativa — exige a sua senha (modo sudo) e obriga o usuário a alterá-la no próximo início de sessão.',
    operatorPassword: 'A sua senha',
    revokeBody: 'Todas as sessões ativas deste usuário são terminadas imediatamente.',
    usernameImmutableHint: 'O nome de usuário é a identidade do account — fixado na criação',
    mustChangePassword: 'Mudança de senha obrigatória',
    tabUsers: 'Usuários',
    mfa: {
      methodsError: 'Não foi possível carregar o registro de métodos',
      resetHint: 'O enrollment e todos os códigos de recuperação são apagados: no próximo início de sessão o usuário refaz o enrollment do zero. A obrigação de MFA fica como está — um administrador nunca define um segredo, apenas o apaga.',
      empty: 'Ainda nenhum usuário gerido — as contas aparecem aqui assim que existem, cada uma com o seu estado do segundo fator.',
      viaGroupHint: 'Obrigação herdada deste grupo: retirar o flag pessoal não liberta o usuário — intervém-se no grupo, no tab Grupos.',
      enforcingSubtitle: 'A âncora da obrigação para as identidades externas é o grupo: os seus mapeamentos de realm dizem a que população de directory chega. O enrollment externo nasce no primeiro início de sessão do usuário obrigado.'
    }
  },
  realms: {
    nameHint: 'O domínio que os usuários escrevem depois do @ (example.com) — imutável depois da criação',
    kindCard: {
      ldap: {
        desc: 'Username e senha verificados com um bind numa directory LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      }
    },
    cleartextWarning: 'Sem ldaps:// ou StartTLS a senha de bind atravessa a rede em claro — aceitável num laboratório, nunca em produção.',
    connectTimeoutHint: 'Prazo por URL de conexão e pedido (1–60); ao expirar tenta-se o URL seguinte',
    bindDnHint: 'O service account que executa a pesquisa do usuário; vazio = search bind anónimo (recusado pelo AD)',
    bindCredential: 'Senha de bind (keystore)',
    bindCredentialHint: 'Uma entrada usernamePassword do keystore com a senha de bind — o segredo nunca vive no realm',
    bindCredentialEmpty: 'Nenhuma entrada usernamePassword no keystore — crie uma em Sistema > Credenciais para a senha de bind.',
    baseDnHint: 'A subárvore de onde parte a pesquisa do usuário (DC=example,DC=com)',
    userFilter: 'Filtro de usuário',
    uuidAttributeHint: 'O UUID imutável no realm (objectGUID no AD, entryUUID no OpenLDAP) — estampado no audit ao lado de usuário@realm',
    displayNameAttributeHint: 'Usado para saudar o usuário; na falta usa-se o nome de login',
    tabConnection: 'Conexão',
    testTitle: 'Testar conexão',
    testHint: 'Uma sonda de configuração, nunca uma autenticação: liga-se, faz o bind com o service account e — com um username — executa o filtro de usuário.',
    testUsername: 'Nome de usuário (opcional)',
    testUsernameHint: 'Uma parte local sobre a qual executar o filtro de usuário — 1 correspondência é a resposta saudável',
    testReachable: 'Directory alcançável, bind de serviço aceito',
    matchedOne: 'O filtro de usuário encontrou exatamente 1 entrada — a resposta saudável.',
    matchedNone: 'O filtro de usuário não encontrou nenhuma entrada: o filtro ou o base DN está errado.',
    matchedMany: 'O filtro de usuário encontrou {count} entradas: não é seletivo, e os inícios de sessão seriam ambíguos (recusados).',
    rootHomeHint: 'As identidades de um realm externo vivem na raiz do cluster, nunca num vDC: as permissões atribuem-se onde forem precisas, com delegações — no grupo ou diretamente no usuário, exatamente como para os nativos.'
  },
  credentials: {
    kindUsernamePassword: 'Username e senha',
    username: 'Nome de usuário'
  },
  proximity: {
    config: {
      save: 'Salvar'
    }
  }
}
